import { useEffect } from "react";

type ScriptProps = {
  id: string;
  src: string;
  type?: string;
};

export const injectScript = (scriptProps: ScriptProps) => {
  const { id, src, type } = scriptProps;
  const existingScript = document.getElementById(id);
  if (!existingScript) {
    const newScript = document.createElement("script");
    newScript.id = id;
    newScript.src = src;
    newScript.type = type ?? "text/javascript";
    document.head.appendChild(newScript);
  }
};

export const useScriptInject = (scriptProps: ScriptProps) => {
  useEffect(() => injectScript(scriptProps), [scriptProps]);
};
